import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-resource-content',
    templateUrl: './resource-content.component.html',
    styleUrls: ['./resource-content.component.less'],
})
export class ResourceContentComponent implements OnInit {
    @Input() currentIndex = 0;
    @Input() listSize = 0;
    @Input() showArrow = true;
    @Output() currentIndexChange = new EventEmitter();

    constructor() {
    }

    ngOnInit(): void {
    }

    toLeft(): void {
        this.currentIndexChange.emit(this.currentIndex - 1);
    }

    toRight(): void {
        this.currentIndexChange.emit(this.currentIndex + 1);
    }

}
